import React from "react";
import {ProductImage} from "./ProductImage";
import {SortableContainer, SortableElement} from "react-sortable-hoc";

const SortableItem = SortableElement(({
                                          attribute, index,
                                          product,
                                          catalog,
                                          partnerId,
                                          uploadUrl,
                                          updateProductState,
                                          disabled
                                      }) => {
    const imageExist = product.Attributes[attribute.Name] !== "" && product.Attributes[attribute.Name] !== undefined;
    const imageMetadata = product.Attributes["image_metadata"] !== undefined && product.Attributes["image_metadata"].find(meta => meta.attribute === attribute.Name);

    return (
        <ProductImage product={product}
                      catalog={catalog}
                      partnerId={partnerId}
                      uploadUrl={uploadUrl}
                      key={`${index}-${attribute.Name}`}
                      listkey={index}
                      updateProductState={updateProductState}
                      attribute={attribute}
                      isPrimary={false}
                      imageExist={imageExist}
                      imageMetadata={imageMetadata}
                      label={attribute.FriendlyName}
                      width={"142px"}
                      height={"164px"}
                      disabled={disabled}
        />
    )
});

const SortableList = SortableContainer(({
                                            images,
                                            product,
                                            catalog,
                                            partnerId,
                                            uploadUrl,
                                            updateProductState,
                                            isPrimary,
                                            width,
                                            height,
                                            disabled
                                        }) => {
    return (
        <div style={{flex: 1, display: "flex", flexWrap: "wrap", overflow: "auto", gap: "5px"}}>
            {images.map((attribute, index) => (
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    attribute={attribute}
                    product={product}
                    catalog={catalog}
                    partnerId={partnerId}
                    uploadUrl={uploadUrl}
                    updateProductState={updateProductState}
                    isPrimary={isPrimary}
                    width={width}
                    height={height}
                    disabled={disabled}
                />
            ))}
        </div>
    );
});


export default function SortableImages(props) {
    const {
        images,
        product,
        catalog,
        partnerId,
        uploadUrl,
        updateProductState,
        isPrimary,
        width,
        height,
        disabled
    } = props;

    return (
        <SortableList
            axis={"xy"}

            useDragHandle={true}
            images={images}
            product={product}
            catalog={catalog}
            partnerId={partnerId}
            uploadUrl={uploadUrl}
            updateProductState={updateProductState}
            isPrimary={isPrimary}
            width={width}
            height={height}
            disabled={disabled}

            onSortEnd={(sortEnd, sortEvent) => {
                const currentImage = product.Attributes[images[sortEnd.oldIndex].Name];
                const replaceWithImage = product.Attributes[images[sortEnd.newIndex].Name];

                updateProductState(images[sortEnd.oldIndex].Name, replaceWithImage);
                updateProductState(images[sortEnd.newIndex].Name, currentImage);
            }}
            onSortStart={(_, event) => event.preventDefault()}
        />
    )
}
